import AnalyticsScreen from './analytics';
import DevicesScreen from './devices';
import ProjectsScreen from './projects';
import SummaryScreen from './summary';
import Authentication from './authentication/authentication.js';
import Profile from './profile';
import AdvancedScreen from './advanced';
import ReportsScreen from './reports';
import InsightScreen from './analytics/insightScreen.js';
import CampaignsScreen from './campaigns/index.js';
import NotFoundScreen from './404';
import NotificationsScreen from './notifications';
import IntegrationsScreen from './integrations';
import LicensesScreen from './licenses';
import PresetsScreen from './presets';
import SitesScreen from './sites';
import SiteGroupsScreen from './sitegroups';
import DiscoveryScreen from './analytics/discoveryScreen.js';
import BrandChartsScreen from './brandAnalytics/index.js';
import WebEmbedScreen from './webAnalytics/index.js';
import FeatureWebAnalyticsScreen from './attributionCharts/index.js';
import PortalsScreen from './portal/index.js';
import PointOfSaleScreen from './pointOfSale/index.js';
import ScreenToStoreScreen from './screenToStore';
import DocumentationScreen from './documentation';

export default {
  AnalyticsScreen,
  DevicesScreen,
  ProjectsScreen,
  SummaryScreen,
  Authentication,
  Profile,
  AdvancedScreen,
  InsightScreen,
  DiscoveryScreen,
  NotFoundScreen,
  ReportsScreen,
  NotificationsScreen,
  IntegrationsScreen,
  CampaignsScreen,
  LicensesScreen,
  PresetsScreen,
  SitesScreen,
  SiteGroupsScreen,
  PortalsScreen,
  BrandChartsScreen,
  WebEmbedScreen,
  FeatureWebAnalyticsScreen,
  PointOfSaleScreen,
  DocumentationScreen,
  ScreenToStoreScreen
};
